const KLAVIYO_POPUP_SELECTOR = '[role="dialog"][aria-label="POPUP Form"]';

const NEWSLETTER_MARKERS = [
  "STAY IN THE LOOP",
  "Stay in the loop",
  "GET A FREE GIFT WITH YOUR FIRST ORDER",
  "Get a free gift with your first order",
];

const TEXT_REPLACEMENTS = new Map([
  ["STAY IN THE LOOP", "Stay in the loop"],
  ["GET A FREE GIFT WITH YOUR FIRST ORDER*", "Get a free gift with your first order*"],
]);

function getText(element) {
  return element.textContent?.trim().replace(/\s+/g, " ") || "";
}

function isNewsletterPopup(popup) {
  const text = getText(popup);

  return NEWSLETTER_MARKERS.some((marker) => text.includes(marker));
}

function normalizeKlaviyoPopup(root = document) {
  const popups = new Set();

  if (root.matches?.(KLAVIYO_POPUP_SELECTOR)) {
    popups.add(root);
  }

  const closestPopup = root.closest?.(KLAVIYO_POPUP_SELECTOR);

  if (closestPopup) {
    popups.add(closestPopup);
  }

  root.querySelectorAll?.(KLAVIYO_POPUP_SELECTOR).forEach((popup) => {
    popups.add(popup);
  });

  popups.forEach((popup) => {
    if (!isNewsletterPopup(popup)) return;

    popup.dataset.kbNewsletterPopup = "true";

    popup.querySelectorAll(".klaviyo-form-richtext span").forEach((span) => {
      const text = getText(span);
      const replacement = TEXT_REPLACEMENTS.get(text);

      if (replacement) {
        span.textContent = replacement;
      }
    });
  });
}

normalizeKlaviyoPopup();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        normalizeKlaviyoPopup(node);
      }
    });
  });
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
